import { IonCard, IonSpinner } from '@ionic/react'
import React from 'react'
import { ChartTimeHook } from '../pages/electricity/charts/consumptionChart/hooks/useChartTimeConsumptionChart'
import ChartTimeSwitch from '../pages/electricity/components/ChartTimeSwitch'
import TimeScroller from './timeScroller'

interface Props {
	children: React.ReactNode
	time: ChartTimeHook
	loading: boolean
	autoHeight?: boolean
	shadow?: boolean
}

const TimeCard: React.FC<Props> = ({ children, time, loading, autoHeight, shadow }) => {
	const defaultStyle = `time-card bg-white dark:bg-background-200-dark border border-[#d7d7d7] dark:border-surface-dark ${shadow ? 'shadow-card' : ''}`

	return (
		<IonCard className={`${defaultStyle} ${loading ? 'loading' : ''}`}>
			<TimeScroller time={time} />

			<div
				className={`content bg-white dark:bg-background-200-dark ${autoHeight ? '!h-auto -mt-4' : ''}`}
			>
				{children}
			</div>
			{loading && <IonSpinner />}

			<ChartTimeSwitch time={time} />
		</IonCard>
	)
}
export default TimeCard
